export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6064.6c8c9332.jpg";